import React from "react";
import { LinkReference } from "../../amorg-common";
import { Modal } from "../Modal";
import { ReferenceLinksPanel } from "./ReferenceLinksPanel";
import { Button } from "../button/Button";
import { getReferenceLinks } from "../../api/referenceLinkClientApi";


export function ReferenceLinksModal (props: {
    show: boolean,
    linkReference: LinkReference,
    title?: string,
    onGetLinksCount?: (count: number) => void,
    onClose: () => void
})
{
    return (
        <Modal 
            showModal={props.show} 
            title={props.title ?? "Vedhæftede links"}
            onCancel={props.onClose}
            content={
                <ReferenceLinksPanel
                    modalEditing={false}
                    hide={false}
                    reference={props.linkReference}
                    onGetLinksCount={props.onGetLinksCount}
                
                />
            } 
        />
    );
}

export function ReferenceLinksModalButton(props: {
    linkReference:LinkReference,
    title?: string,
    disabled?: boolean,
}) {
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [linkCount, setLinkCount] = React.useState<number | undefined>(undefined);

    React.useEffect(() => {
        const getData = async () => {
            const count = (await getReferenceLinks(props.linkReference.id, props.linkReference.type ))?.links.length ?? 0;
            setLinkCount(count);
        };
        getData();
    }, [props.linkReference]);

    function handleGetLinksCount(count: number) {
        setLinkCount(count);
    }

    async function handleCloseModal() {
        setShowModal(false);
    }


    return (
        <>
            <Button 
                variant={linkCount ? 'text' : 'dimmed'} 
                size="32px"
                icon="interface_actions_link" 
                text={linkCount === undefined 
                    ? `Tilknyttede links` 
                    : `Tilknyttede links (${linkCount})`
                }
                onClick={() => setShowModal(true)}
                disabled={props.disabled} />

            <ReferenceLinksModal
                show={showModal}
                linkReference={props.linkReference}
                title={props.title}
                onGetLinksCount={handleGetLinksCount}
                onClose={handleCloseModal}
            />
        </>
    );
}
